import { actionCreatorFactory } from 'typescript-fsa';

const actionCreator = actionCreatorFactory('timely/global');
export const completeGlobalFetch = actionCreator('COMPLETE_GLOBAL_FETCH');
export const setUserAsIdle = actionCreator<boolean>('SET_USER_AS_IDLE');
export const setInitializedAssetRevisionForDevTool = actionCreator<string | null>(
  'SET_INITIALIZED_ASSET_REVISION__DEV'
);
export const setAvailableAssetRevision = actionCreator<string | null>(
  'SET_INITIALIZED_ASSET_REVISION'
);
export const toggleKeyboardShortcutModal = actionCreator('TOGGLE_KEYBOARD_SHORTCUT_MODAL');
export const setUserIsOnline = actionCreator<boolean>('SET_USER_IS_ONLINE');
export const setElectronUpdateStatus = actionCreator<ElectronUpdateStatus>(
  'SET_ELECTRON_UPDATE_STATUS'
);
export const toggleDatePickerDropdownRangeMode = actionCreator(
  'TOGGLE_DATE_PICKER_DROPDOWN_RANGE_MODE'
);
export const toggleClientReportDatePickerRangeMode = actionCreator(
  'TOGGLE_CLIENT_REPORT_DATE_PICKER_RANGE_MODE'
);

export const setDetectedTimezone = actionCreator<string>('SET_DETECTED_TIMEZONE');

export type ElectronUpdateStatus = null | 'downloading-update' | 'update-ready';

export interface State {
  isUserIdle: boolean;
  isUserOnline: boolean;
  idleSince: string | null;
  initializedAt: string | null;
  initializedAssetRevision: string | null;
  availableAssetRevision: string | null;
  requestedAssetRevision: string | null;
  showKeyboardShortcutModal: boolean;
  electronUpdateStatus: ElectronUpdateStatus;
  datePickerDropdown: {
    isRange: boolean;
  };
  clientReportDatePickerDropdown: {
    isRange: boolean;
  };
  detectedTimezone: string;
}
